export function getUniqueRelationshipIds<T extends { id: number }>({
  main,
  primary,
}: {
  main: T[];
  primary: T[];
}): { mainIds: number[]; primaryIds: number[]; alternateIds: number[] } {
  const mainIds = new Set<number>();
  main.forEach((item) => mainIds.add(item.id));

  const primaryIds = new Set<number>();
  primary.forEach((item) => {
    if (mainIds.has(item.id)) {
      primaryIds.add(item.id);
    }
  });

  const alternateIds: number[] = [];
  mainIds.forEach((id) => {
    if (!primaryIds.has(id)) {
      alternateIds.push(id);
    }
  });

  return { mainIds: Array.from(mainIds), primaryIds: Array.from(primaryIds), alternateIds };
}
